module.exports = __webpack_public_path__ + "bz.svg?2458dd8a8870ea822b25e1cbbd9cb0a9";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/bz.svg
// module id = 1282
// module chunks = 0